import AlertMessage from '@/app/components/AlertMessage'

type Props = {
  /**
   * Display name of the prescribed setting, e.g. "Save Money".
   */
  settingDisplayName: string
}

/**
 * Renders the "<setting> setting is required to be turned on to be eligible
 * for this program" copy as an info alert.
 *
 * Centralized here so all three configure-devices step PRs share the exact copy.
 */
export default function ProgramPrescribedAlert({ settingDisplayName }: Props) {
  return (
    <AlertMessage variant="info">
      {settingDisplayName} setting is required to be turned on to be eligible
      for this program
    </AlertMessage>
  )
}
